import { GiftCode } from '@/models/GiftCode';

const headerKeys = ['code', 'price', 'isLoaded'];
const headerRowNum = 1;

const clientId = SPREADSHEET_CLIENT_ID;
const discoveryDocs = ['https://sheets.googleapis.com/$discovery/rest?version=v4'];
const scope = 'https://www.googleapis.com/auth/spreadsheets';

const init = () => {
  gapi.load('client:auth2', async () => {
    await gapi.client.init({
      clientId,
      discoveryDocs,
      scope,
    });
  });
};

init();

const extractSpreadsheetIdFromUrl = (spreadsheetUrl: string): string =>
  (/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/.exec(spreadsheetUrl) || ['', ''])[1] || '';

const mapSpreadsheetDataToAppModel = (spreadsheetSheetData: any[][]): GiftCode[] => {
  if (!spreadsheetSheetData || spreadsheetSheetData.length === 0) {
    return [];
  }

  const sheetDataHeaderRow = spreadsheetSheetData[0];
  if (
    headerKeys.filter((key: string, index: number) => key === sheetDataHeaderRow[index]).length !== headerKeys.length
  ) {
    return [];
  }

  return spreadsheetSheetData.slice(headerRowNum).map((sheetDataRow) => {
    const [code, price, isLoaded] = sheetDataRow;
    return {
      code,
      price: /^[0-9]+$/.test(price) ? parseInt(price, 10) : NaN,
      isLoaded: isLoaded === 'true',
    };
  });
};

const mapAppModelToSpreadsheetModel = (giftCodeList: GiftCode[]): string[][] => {
  if (!giftCodeList || giftCodeList.length < 1) {
    return [];
  }

  return giftCodeList.map((giftCode) => [
    giftCode.code.toString(),
    giftCode.price.toString(),
    giftCode.isLoaded.toString(),
  ]);
};

const fetchSpreadsheetGiftCodeData = async (spreadsheetUrl: string, sheetName: string): Promise<GiftCode[]> => {
  if (!gapi.auth2.getAuthInstance().isSignedIn.get()) {
    await gapi.auth2.getAuthInstance().signIn();
  }

  const spreadsheetId = extractSpreadsheetIdFromUrl(spreadsheetUrl);
  const response = await gapi.client.sheets.spreadsheets.values.get({
    spreadsheetId,
    range: sheetName,
  });

  return mapSpreadsheetDataToAppModel(response.result.values);
};

const writeGiftCodeDataToSpreadsheet = async (
  spreadsheetUrl: string,
  sheetName: string,
  giftCodeList: GiftCode[]
): Promise<gapi.client.Response<gapi.client.sheets.UpdateValuesResponse>> => {
  if (!gapi.auth2.getAuthInstance().isSignedIn.get()) {
    await gapi.auth2.getAuthInstance().signIn();
  }

  const spreadsheetId = extractSpreadsheetIdFromUrl(spreadsheetUrl);
  const response = await gapi.client.sheets.spreadsheets.values.update({
    spreadsheetId,
    range: sheetName,
    valueInputOption: 'RAW',
    resource: {
      values: [headerKeys].concat(mapAppModelToSpreadsheetModel(giftCodeList)),
    },
  });

  return response;
};

export { fetchSpreadsheetGiftCodeData, writeGiftCodeDataToSpreadsheet };
